import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';

import IconButton from 'components/common/IconButton';
import IconMessageBank from 'components/icons/IconMessageBank';
import Menu from 'components/common/Menu';

import { fetchPatientMessageTemplates } from 'redux/modules/patientsMessagesTemplates';

import throttle from 'utils/throttle';

import NotificationsDialogTemplatesItem from './NotificationsDialogTemplatesItem';

const styles = () => ({
  iconMessageBank: {
    minWidth: 48,
    margin: 0,
  },
});

class NotificationsDialogTemplates extends Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
      limit: 10,
      offset: 0,
    };

    this.onRequest = this.onRequest.bind(this);
    this.onMenuClose = this.onMenuClose.bind(this);
    this.onTemplatesButtonClick = this.onTemplatesButtonClick.bind(this);
    this.onTemplatesScrollFetchRequest = this.onTemplatesScrollFetchRequest.bind(this);

    this.onRequest = throttle(this.onRequest);
  }

  componentDidMount() {
    this.onRequest();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.patientsMessagesTemplates.length === 0) {
      this.setState({ anchorEl: null });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { limit, offset } = this.state;
    const limitChanged = prevState.limit !== limit;
    const offsetChanged = prevState.offset !== offset;
    if (limitChanged || offsetChanged) {
      this.onRequest();
    }
  }

  onRequest() {
    const { actions, account } = this.props;
    const { offset, limit } = this.state;
    actions.fetchPatientMessageTemplates({
      filters: [{
        name: 'User ID',
        operation: 'eq',
        val: account.ID,
      }],
      triggerLoading: false,
      push: true,
      limit,
      offset,
    });
  }

  onMenuClose() {
    this.setState({ anchorEl: null });
  }

  onTemplatesButtonClick(event) {
    this.setState({
      anchorEl: event.currentTarget,
    });
  }

  onTemplatesScrollFetchRequest() {
    const { patientsMessagesTemplates } = this.props;
    const { offset, limit } = this.state;
    if ((patientsMessagesTemplates.length - limit) >= offset) {
      this.setState({ offset: offset + limit });
    }
  }

  render() {
    const {
      patientsMessagesTemplates,
      onTemplateSelect,
      classes,
    } = this.props;
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);
    return (
      <Fragment>
        <IconButton
          className={classes.iconButton}
          onClick={this.onTemplatesButtonClick}
          tooltipContent="SMS Templates"
          disabled={patientsMessagesTemplates.length === 0}
          aria-label="More"
          aria-owns="notifications-templates-menu"
          aria-haspopup="true"
        >
          <IconMessageBank className={classes.iconMessageBank} />
        </IconButton>
        {patientsMessagesTemplates.length > 0 &&
          <Menu
            id="notifications-templates-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={this.onMenuClose}
            onScrollFrame={(event) => {
              if (event.top > 0.8) {
                this.onTemplatesScrollFetchRequest();
              }
            }}
          >
            {patientsMessagesTemplates.map(item => (
              <NotificationsDialogTemplatesItem
                key={item.ID}
                onClick={this.onMenuClose}
                {...item}
                onTemplateSelect={(template) => {
                  this.onMenuClose();
                  onTemplateSelect(template);
                }}
              />
            ))}
          </Menu>
        }
      </Fragment>
    );
  }
}

NotificationsDialogTemplates.propTypes = {
  account: PropTypes.shape({
    ID: PropTypes.number,
  }),
  patientsMessagesTemplates: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number,
  })).isRequired,
  actions: PropTypes.shape({
    fetchPatientMessageTemplates: PropTypes.func.isRequired,
  }).isRequired,
  onTemplateSelect: PropTypes.func,
  classes: PropTypes.shape({
    iconMessageBank: PropTypes.string.isRequired,
  }).isRequired,
};

NotificationsDialogTemplates.defaultProps = {
  onTemplateSelect: () => {},
};

const mapStateToProps = store => ({
  patientsMessagesTemplates: store.patientsMessagesTemplates.data,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ fetchPatientMessageTemplates }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(NotificationsDialogTemplates),
);



// WEBPACK FOOTER //
// ./src/components/patient/NotificationsDialog/NotificationsDialogTemplates.js